/**
 * ReplyPreview Component
 * Preview del messaggio a cui si sta rispondendo nell'input
 */

import { memo } from 'react';
import { X, Reply } from 'lucide-react';
import type { Message } from '@/lib/types/whatsappChat';

interface ReplyPreviewProps {
  message: Message;
  onCancel: () => void;
}

export const ReplyPreview = memo(function ReplyPreview({
  message,
  onCancel,
}: ReplyPreviewProps) {
  const isOutbound = message.direction === 'outbound';

  return (
    <div className="flex items-center gap-2 px-4 py-2 bg-[rgba(55,53,47,0.04)] dark:bg-white/5 border-t border-[rgba(55,53,47,0.09)] dark:border-white/10">
      <Reply className="w-4 h-4 text-[#2383E2] flex-shrink-0" />

      <div className="flex-1 min-w-0 pl-2 border-l-2 border-[#2383E2]">
        <p className="text-xs font-medium text-[#2383E2]">
          {isOutbound ? 'Tu' : 'Rispondendo a'}
        </p>
        <p className="text-sm text-[#787774] truncate">
          {message.content || `📎 ${message.type}`}
        </p>
      </div>

      <button
        onClick={onCancel}
        className="p-1 rounded hover:bg-[rgba(55,53,47,0.08)] dark:hover:bg-white/10 transition-colors"
      >
        <X className="w-4 h-4 text-[#787774]" />
      </button>
    </div>
  );
});
